import Tracking, { CartJson, JsProductInfo } from "./Tracking";

export interface AddCartProductInfo extends JsProductInfo {
    quantity: number;
}

export default class Cart {
    private static cartpage_inited = false;

    public static onCartItemQuantityUpdate(info: JsProductInfo, prev: number, current: number): void {
        Tracking.eventChangeCart(info, prev, current);
    }

    public static onCartItems($uid: JQuery): void {
        function update(info: AddCartProductInfo, quantity) {
            $('body').trigger('cartUpdateInit');

            Cart.onCartItemQuantityUpdate(info, info.quantity, quantity);

            $.post('/cartapi/set', {
                id: info.cartid,
                quantity: quantity
            }, function() {
                $('body').trigger('cartUpdate');
            });
        }

        $('.cart-products__item').each((ix, el) => {
            const $item = $(el);

            const $quantity = $('.quantity input', $item);
            const $remove = $('.remove', $item);

            const info: AddCartProductInfo = $item.data('info');
            info.quantity = parseInt($quantity.val());

            (<any> $quantity).qSpinner({
                value: $quantity.val(),

                onLazySpin: function(e, val) {
                    update(info, val);
                }
            });

            $quantity.on('change', (e) => {
                update(info, $quantity.val());
            });

            $remove.on('click', (e) => {
                e.preventDefault();

                update(info, 0);
            });
        });

        (<any> window).updateElements($uid);
    }

    public static onCartCompletePage(fbtrack: any): void {
        Tracking.eventPurchase(fbtrack);
    }

    public static onCartServices($uid: JQuery): void {
        $('.cart-service', $uid).each((ix, el2) => {
            const $group = $(el2);
            const type = $group.data('type');

            $('.item', $group).each((ix, el) => {
                const $service = $(el);
                const $input = $(':input', $service);
                const title = $('.title', $service).text();

                $input.on('change', (e) => {
                    $('body').trigger('cartUpdateInit');

                    const data = {
                        group: $input.data('group'),
                        id: $input.val()
                    };

                    $.post('/cartapi/services', data, () => {
                        $('body').trigger('cartUpdate');

                        Tracking.event('update-services');

                        if (type == 'delivery') {
                            Tracking.event('update-delivery', {
                                servicetitle: title,
                            });
                        }
                    });
                });
            });
        });
    }

    public static onCartServicesPage(cart: CartJson): void {
        Tracking.eventCartCheckout(cart);
    }

    public static onCartUserPage(cart: CartJson): void {
        let type = null;

        if ($('.vcartuser__login').length) {
            type = 'login';
        } else if ($('.vcartuser--verify').length) {
            type = 'verify';
        }

        Tracking.eventCartUser(cart, type);
    }

    public static onCartForm($uid: JQuery): void {
        $('body').one('cartUpdateInit', () => {
            $uid.find(':input').prop('disable', 'disable');

            (<any> $uid).ajaxLoader();
        });

        $('body').one('cartUpdate', () => {
            (<any> $uid).ajaxUpdate($uid.data('form'));
        });
    }

    public static apiAddToCart(id: string, quantity: number = 1, onsuccess?: () => void): void {
        $.post('/cartapi/add', {
            id: id,
            quantity: quantity,
        }, (r) => {
            if (onsuccess) {
                onsuccess();
            }
        });
    }

    public static addToCart(product: AddCartProductInfo, onsuccess?: () => void): void {
        const CSS_ADD = 'body--addingtocart';

        const $body = $('body');

        if ($body.hasClass(CSS_ADD)) {
            return;
        }

        $body.addClass(CSS_ADD);

        $body.trigger('cartUpdateInit');

        this.apiAddToCart(product.cartid, product.quantity, () => {
            Tracking.eventAddToCart(product);

            $body.trigger('cartUpdate');

            $body.removeClass(CSS_ADD);

            if (onsuccess) {
                onsuccess();
            }
        });
    }

    public static initAddToCart(): void {
        (<any> $.fn).addToCart=function(options) {
            var $this=$(this);

            var $quantity=$('.js-addtocart__quantity', $this);
            var $button=$('.js-addtocart__button', $this);

            var adding=false;

            function reset() {
                $quantity.val(1);
            }

            function submit() {
                if (adding) {
                    return;
                }

                adding=true;

                $this.addClass('addtocart--added');

                const info: AddCartProductInfo = $this.data('info');
                info.quantity = parseInt($quantity.val() ? $quantity.val() : 1);

                Cart.addToCart(info, () => {
                    reset();

                    window.setTimeout(function() {
                        $this.removeClass('addtocart--added');

                        adding = false;
                    }, 2000);
                });
            }

            $button.click(function (e) {
                e.preventDefault();

                submit();
            });
        }

        $(document).ready(function() {
            var timer=null;

            $('body').on('cartUpdate', function() {
                if (timer!==null) {
                    window.clearTimeout(timer);
                    timer=null;
                }

                $.get('/cartapi/info', function(info) {
                    var $info=$('.header__cart, .footer-mobile__cart');

                    $info.addClass('flash');
                    $info.toggleClass('active', info.total > 0);

                    $('span', $info).text(info.total);

                    timer=window.setTimeout(function () {
                        $info.removeClass('flash');
                    }, 2000);
                });
            });

            $('.js-addtocart').each(function() {
                (<any> $(this)).addToCart();
            });
        });
    }

    public static discover($parent?: JQuery): void {
        $('.js-addtocartsimple').each((ix, el) => {
            const $el = $(el);

            $el.on('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const info: AddCartProductInfo = $el.data('info');
                info.quantity = parseInt($el.data('quantity') ? $el.data('quantity') : 1);

                Cart.addToCart(info);
            });
        });
    }

    public static init(): void {
        this.initAddToCart();
    }
}
